import {VisitAPIDataSourceCore} from '../api/VisitAPIDataSourceCore';
import {mapVisitTrendsDTOToModel} from '../mappers/visit.mapper';
import {VisitTrends} from '../models/visit.model';

/**
 * Use case for fetching visit trends data
 * Follows clean architecture pattern
 */
export class GetVisitTrendsUseCase {
  async execute (): Promise<VisitTrends> {
    const dto = await VisitAPIDataSourceCore.getTrends();
    return mapVisitTrendsDTOToModel(dto);
  }
}
